// Keep the header total independent of loaded/filtered conversation previews.
export function subscribeUnreadCount(socket: any, refresh: () => void, target: Window = window) {
  let timer: ReturnType<typeof setTimeout>;
  const schedule = () => {
    clearTimeout(timer);
    timer = setTimeout(refresh, 100);
  };
  const events = ["connect", "job:chat:receive", "readMessage"];
  events.forEach(event => socket.on(event, schedule));
  target.addEventListener("focus", schedule);
  return () => {
    clearTimeout(timer);
    events.forEach(event => socket.off(event, schedule));
    target.removeEventListener("focus", schedule);
  };
}
